import { EmployeeBase, TopUpFrequency } from './employee.interface';
import { CardMinimal } from './cards.interface';

interface CardTopupBase {
  type: CardTopupType;
  amount: string;
  frequency: TopUpFrequency;
  date_start: string;
  date_end: string;
}

export interface CardTopupRequest extends CardTopupBase {
  card: number;
}

export interface CardTopup extends CardTopupBase {
  id: string;
  is_removed: boolean;
  card: CardMinimal;
  employee: EmployeeBase;
  schedule_status: CardScheduleStatus;
}

export enum CardTopupType {
  Recurring = 1,
  Scheduled = 2,
}

export enum CardScheduleStatus {
  Pending = 1,
  Active = 2,
  Completed = 3,
}

export enum CardScheduleStatusLabel {
  PENDING = 'Pending',
  ACTIVE = 'Active',
  COMPLETED = 'Completed',
}
